import { Home, User, Settings } from "lucide-react";
import { ICON_REGISTRY, IconName } from "../utils/icon-registry";

export const Icon = ({
  name,
  size = 24,
  color = "#000",
}: {
  name: string;
  size: number;
  color?: string;
}) => {
  const IconComp = ICON_REGISTRY[name as keyof typeof ICON_REGISTRY];
  if (!IconComp) return null;

  return <IconComp size={size} stroke={color} />;
};
